import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../pages/mobile/home.vue"),
  },
  {
    path: "/found",
    name: "Found",
    component: () => import("../pages/mobile/founds.vue"),
  },
  {
    path: "/storeDetails",
    name: "StoreDetails",
    component: () => import("../pages/mobile/storeDetails.vue"),
  },
  {
    path: "/hall",
    name: "Hall",
    component: () => import("../pages/mobile/hall.vue"),
  },
  // 黑金专区
  {
    path: "/hall",
    name: "Hall",
    component: () => import("../pages/mobile/black-vip-zone.vue"),
  },
  {
    path: "/china",
    name: "China",
    component: () => import("../pages/mobile/china_new.vue"),
  },
  {
    // 地图导航
    path: "/map",
    name: "Map",
    component: () => import("../pages/pc/map.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/mobile",
  routes,
});

export default router;
